import styled from "styled-components";
import { Heading, Logo, Button, Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const LandingPageStyled = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
`;

export const HeadingStyled = styled(Heading)`
  width: 100%;
  font-weight: normal;
`;

export const TextStyled = styled(Text)`
  font-weight: normal;
  margin-bottom: ${props => props.theme.spacing.small};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.spacing.small};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: normal;
  display: inline-block;
  margin-bottom: ${props => props.theme.spacing.small};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
`;

export const LinkStyled = styled.span`
  border: 2px solid ${props => props.theme.color.greyDarker};
  border-radius: 8px;
  font-size: ${props => props.theme.font.size.default};
  font-weight: ${props => props.theme.font.weight.bold};
  padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.xlarge};
  color: ${props => props.theme.color.white};
  display: inline-block;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: calc(${props =>
  props.theme.font.size.xlarge} + 2rem);
`;

export const PinContainerStyled = styled.div`
  width: ${props => (props.locale == "en" ? "50%" : "35%")};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing.medium};
  direction: ltr;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: calc(${props =>
  props.theme.font.size.xlarge} + 2rem);
`;

export const PinItemStyled = styled.span`
  border: 2px solid ${props => props.theme.color.greyDarker};
  border-radius: 8px;
  font-size: ${props => props.theme.font.size.xlarge};
  font-weight: ${props => props.theme.font.weight.bold};
  color: ${props => props.theme.color.white};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23%;
  height: 1.8em;
`;

export const LandingContainerStyled = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
`;

export const ButtonModalStyled = styled(Button)`
  display: block;
  margin-top: ${props => props.theme.spacing.xsmall};
  width: 35%;
  margin: 0 auto;
`;

export const LogoStyled = styled(Logo)`
  display: inline-block;
  width: unset;
  height: 3.5vw;
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
    props.theme.spacing.large}
`;

export const LineTextStyled = styled.h1`
  overflow: hidden;
  text-align: center;
  color: ${props => props.theme.color.white};
  font-weight: ${props => props.theme.font.weight.regular};
  width: calc(100% - 100px);
  margin: 0 auto;
  margin-bottom: ${props => props.theme.spacing.medium};
  &:before,
  &:after {
    background-color: ${props => props.theme.color.greyDarker};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 50%;
  }

  &:before {
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 0.5em;
    margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: -50%;
  }

  &:after {
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 0.5em;
    margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: -50%;
  }

`;

export const SecondaryLogoStyled = styled.img`
  vertical-align: middle;
  & + & {
    margin: 0 15px;
  }
`;

export const LeftBlock = styled.div`
  display: flex;
  width: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "50%" : "50%")};
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: ${props =>
  props.theme.spacing.large};
  padding-top: ${props => props.theme.spacing.large};
  flex: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT || props.userLocale === "fr" ? "8" : "5")};
`;

export const RightBlock = styled.div`
  display: flex;
  width: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "50%" : "50%")};
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.spacing.large};
  padding-top: ${props => props.theme.spacing.large};
  flex: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT || props.userLocale === "fr" ? "3" : "5")};
`;

export const AlignText = styled.div`
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
`;

export const StepContainer = styled.span`
  vertical-align: middle;
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.font.size.medium};
  width: 100%;
  margin-bottom: ${props => props.theme.spacing.xsmall};
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  display: inline-block;
  width: calc(${props => props.theme.spacing.xlarge});
  height: calc(${props => props.theme.spacing.xlarge});
  padding: ${props => props.theme.spacing.xsmall};
  border: 3px solid ${props => props.theme.color.grey};
  color: ${props => props.theme.color.white};
  text-align: center;
  font-size: ${props => props.theme.font.size.large};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
  props.theme.font.size.medium};
`;

export const StepTextContainer = styled.span`
  vertical-align: middle;
  display: inline;
`;
export const QRCode = styled.img`
  width: 25vw;
  height: 25vw;
  border: 20px solid #fff;
  border-radius: ${props => props.theme.spacing.small};
  position: absolute;
  top: calc(${props => props.theme.spacing.xlarge} * 3);
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
    props.theme.spacing.xlarge};
`;
export const PinLoginInfoContainer = styled.div`
  display: flex;
`;
export const LoginOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
